export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const GEO_SEARCH_REQUEST = 'GEO_SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const SEARCH_RESET = 'SEARCH_RESET';
export const SET_CURRENT_THRESHOLD = 'SET_CURRENT_THRESHOLD';
